import { render } from "./RequestTutorView.vue?vue&type=template&id=a239c4ae&ts=true"
import script from "./RequestTutorView.vue?vue&type=script&lang=ts"
export * from "./RequestTutorView.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__